var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import Pagination from "../../common/components/Pagination";
import { Loading } from 'element-ui';
import { mapGetters } from "vuex";
import RechargeManageService from "../../api/RechargeManageService";
import CommonService from "../../api/CommonService";
import { EBillType } from "../../enum/EBillType";
import { UrlHelper } from "../../helper/UrlWrapper";
import { billDefaultDate } from "../../helper/defaultDate";
import { EPurSortingStatus } from "../../enum/EStatus";
import AreaShop from "@/components/AreaShop";
import { toDetail } from '../../helper/util';
function getDefaultFormData() {
    return {
        text: "",
        dateType: "1",
        s_time: billDefaultDate().Start.format('yyyy-MM-dd'),
        e_time: billDefaultDate().End.format('yyyy-MM-dd'),
        rechargeStatus: [0, 1],
        shop: null,
        rechargeType: -1
    };
}
function tidyDepotList(treeData) {
    treeData.forEach(function (item) {
        if (item.organ_id && !item.depot_id) {
            item.isDisabled = true;
            item.depot_id = "organ_id_" + item.organ_id;
            item.depot_name = item.organ_name;
        }
        if (item.children && item.children.length) {
            tidyDepotList(item.children);
        }
    });
}
var PurSorting = (function (_super) {
    __extends(PurSorting, _super);
    function PurSorting() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = getDefaultFormData();
        _this.statusList = [];
        _this.tableData = [];
        _this.selectedData = [];
        _this.tableHeight = 0;
        _this.total = 0;
        _this.eBillType = EBillType;
        _this.ePurSortingStatus = EPurSortingStatus;
        _this.dialogVisible = false;
        _this.exportType = "1";
        _this.isMoreSearch = false;
        _this.dateTypeList = [{ name: "创建日期", id: "1" }, { name: "审核日期", id: "2" }, { name: "废弃日期", id: "3" }];
        _this.depotList = [];
        _this.exportDetail = {};
        _this.importTypeList = [
            { id: 1, name: '分拣导出-门店分拣' },
            { id: 2, name: '分拣导出-货品分拣' }
        ];
        _this.importType = 1;
        _this.dialogTableVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        _this.organBusiness = [];
        _this.rechargeTypeList = [
            {
                id: -1,
                name: "全部"
            },
            {
                id: 1,
                name: "手动充值"
            },
            {
                id: 2,
                name: "手动扣款"
            },
            {
                id: 3,
                name: "退款充值"
            },
        ];
        _this.rechargeStatusList = [
            {
                id: -1,
                name: "全部"
            },
            {
                id: 0,
                name: "待审核"
            },
            {
                id: 1,
                name: "已审核"
            },
        ];
        _this.handleRecharge = false;
        _this.handleDeduction = false;
        _this.handleEdit = false;
        _this.moneyForm = {
            shop: null,
            moneyNum: "",
            moneyRemark: "",
            business: null,
            balance: null
        };
        _this.deductionForm = {
            shop: null,
            moneyNum: "",
            moneyRemark: "",
            business: null,
            balance: null
        };
        _this.editForm = {
            order_icomment: null,
            order_money: null,
        };
        _this.formLabelWidth = '100px';
        _this.validateMoneyNum = function (rule, value, callback) {
            if (value === '') {
                callback(new Error('请输入金额'));
            }
            else {
                value = value + '';
                if (value.indexOf(".") > -1) {
                    var valueIndex = value.indexOf(".") + 1;
                    var valueCount = value.length - valueIndex;
                    if (valueCount > 4) {
                        callback(new Error('小数点后位数不能大于4位'));
                        return false;
                    }
                }
                callback();
            }
        };
        _this.editFormRules = {
            order_money: [
                { validator: _this.validateMoneyNum, trigger: 'change' },
                { required: true, message: '请输入金额', trigger: 'change' }
            ],
            order_icomment: [
                { required: true, message: '请输入备注', trigger: 'change' },
                { max: 50, message: '备注需小于50个字符', trigger: 'change' }
            ],
        };
        _this.moneyFormRules = {
            shop: [
                { required: true, message: '请选择充值门店', trigger: 'change' },
            ],
            moneyNum: [
                { validator: _this.validateMoneyNum, trigger: 'change' },
                { required: true, message: '请输入充值金额', trigger: 'change' }
            ],
            moneyRemark: [
                { required: true, message: '请输入充值备注', trigger: 'change' },
                { max: 50, message: '充值备注需小于50个字符', trigger: 'change' }
            ],
        };
        _this.deductionFormRules = {
            shop: [
                { required: true, message: '请选择扣款门店', trigger: 'change' },
            ],
            moneyNum: [
                { validator: _this.validateMoneyNum, trigger: 'change' },
                { required: true, message: '请输入扣款金额', trigger: 'change' }
            ],
            moneyRemark: [
                { required: true, message: '请输入扣款备注', trigger: 'change' },
                { max: 50, message: '扣款备注需小于50个字符', trigger: 'change' }
            ],
        };
        return _this;
    }
    PurSorting.prototype.watchMoneyFormBusiness = function (newValue, oldValue) {
        if (newValue) {
            for (var i = 0; i < this.organBusiness.length; i++) {
                var data = this.organBusiness[i];
                for (var j = 0; j < data.children.length; j++) {
                    if (data.children[j].id == newValue) {
                        this.moneyForm.business = data.id;
                        this.moneyForm.balance = data.children[j].money;
                        return;
                    }
                }
            }
        }
    };
    PurSorting.prototype.watchDeductionFormBusiness = function (newValue, oldValue) {
        if (newValue) {
            for (var i = 0; i < this.organBusiness.length; i++) {
                var data = this.organBusiness[i];
                for (var j = 0; j < data.children.length; j++) {
                    if (data.children[j].id == newValue) {
                        this.deductionForm.business = data.id;
                        this.deductionForm.balance = data.children[j].money;
                        return;
                    }
                }
            }
        }
    };
    PurSorting.prototype.created = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.$el && _this.$el.parentElement) {
                _this.tableHeight = _this.$el.parentElement.clientHeight - 150;
            }
        }, 300);
        this.service = RechargeManageService.getInstance();
        this.commonService = CommonService.getInstance();
        console.log(this.Root_PageAuth, "Root_PageAuth");
    };
    PurSorting.prototype.mounted = function () {
        this.areaShopComp = this.$refs.areaShopRef;
        this.getOrganDepot({ type: 3, freeze: 0 });
        this.getList();
    };
    PurSorting.prototype.getOrganDepot = function (params) {
        var _this = this;
        params = params ? params : {
            type: 1
        };
        this.commonService.getShopFilter(params).then(function (res) {
            if (res.data.success) {
                var depot = Array.isArray(res.data.data) ? res.data.data : [];
                _this.organBusiness = depot;
                console.log(_this.organBusiness);
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    PurSorting.prototype.normalizer = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    PurSorting.prototype.shopSelect = function (node) {
        this.formData.shop = node.shop_contact;
    };
    PurSorting.prototype.shopSelectDeduction = function (node) {
        for (var i = 0; i < this.organBusiness.length; i++) {
            var data = this.organBusiness[i];
            for (var j = 0; j < data.children.length; j++) {
                if (data.children[j].id == node.id) {
                    this.moneyForm.business = data.id;
                    return;
                }
            }
        }
    };
    PurSorting.prototype.shopSelectRecharge = function (node) {
        for (var i = 0; i < this.organBusiness.length; i++) {
            var data = this.organBusiness[i];
            for (var j = 0; j < data.children.length; j++) {
                if (data.children[j].id == node.id) {
                    this.deductionForm.business = data.id;
                    return;
                }
            }
        }
    };
    PurSorting.prototype.handleRechargeClick = function () {
        this.moneyForm = {
            shop: null,
            moneyNum: null,
            moneyRemark: null,
            business: null,
            balance: null,
        };
        this.handleRecharge = true;
        this.getOrganDepot({
            type: 1,
            freeze: 0,
        });
    };
    PurSorting.prototype.handleDeductionClick = function () {
        this.deductionForm = {
            shop: null,
            moneyNum: null,
            moneyRemark: null,
            business: null,
            balance: null,
        };
        this.handleDeduction = true;
        this.getOrganDepot({
            type: 1,
            freeze: 0,
        });
    };
    PurSorting.prototype.submitForm = function (formName) {
        var _this = this;
        this.$refs[formName].validate(function (valid) {
            if (valid) {
                if (formName == "deductionForm") {
                    _this.handleDeduction = false;
                    _this.deduction();
                }
                else if (formName == "moneyForm") {
                    _this.handleRecharge = false;
                    _this.recharge();
                }
                else if (formName == "editForm") {
                    _this.handleEdit = false;
                    _this.updateOrder();
                }
            }
            else {
                console.log('error submit!!');
                return false;
            }
        });
    };
    PurSorting.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        if (this.isMoreSearch) {
            this.isMoreSearch = false;
        }
        ;
        console.log(this.shopCode, "shopCode");
        var params = {
            keyword: this.formData.text,
            time_type: this.formData.dateType,
            s_time: this.formData.s_time,
            e_time: this.formData.e_time,
            shop_ids: this.formData.shop ? (this.formData.shop || []).join(',') : this.shopCode,
            order_type: this.formData.rechargeType,
            order_status: this.formData.rechargeStatus.join(","),
        };
        Object.assign(params, pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getList(params).then(function (res) {
            var data = res.data.data;
            _this.tableData = data;
            _this.total = res.data.total;
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PurSorting.prototype.pageChange = function () {
        this.getList();
    };
    PurSorting.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            this.order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        this.getList();
    };
    PurSorting.prototype.selectionChange = function (val) {
        this.selectedData = val;
    };
    PurSorting.prototype.searchClick = function () {
        this.$refs.pagination.clear();
        this.getList();
    };
    PurSorting.prototype.reset = function () {
        this.formData = getDefaultFormData();
    };
    PurSorting.prototype.getSelectIds = function () {
        var orderIds = this.selectedData.map(function (item) { return item.order_id; });
        return orderIds;
    };
    PurSorting.prototype.lookDetail = function (row) {
        toDetail(EBillType.PurSorting, row.order_id, this);
    };
    PurSorting.prototype.audit = function (data) {
        if (data.order_id) {
            this.auditOrder({ order_ids: data.order_id });
        }
        else {
            if (!this.selectedData.length) {
                this.$message.warning("请选择单据");
                return;
            }
            this.auditOrder({ order_ids: this.selectedData.map(function (item) { return item.order_id; }).join(",") });
        }
    };
    PurSorting.prototype.auditOrder = function (params) {
        var _this = this;
        console.log(params, "审核单据");
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.audit(params).then(function (res) {
            if (res.data.code == 76) {
                _this.$message.error(res.data.msg);
            }
            else {
                _this.$message.success(res.data.msg || "审核成功！");
            }
            _this.getList();
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PurSorting.prototype.discard = function (data) {
        if (data.order_id) {
            this.discardOrder({ order_ids: data.order_id });
        }
        else {
            if (!this.selectedData.length) {
                this.$message.warning("请选择单据");
                return;
            }
            this.discardOrder({ order_ids: this.selectedData.map(function (item) { return item.order_id; }).join(",") });
        }
    };
    PurSorting.prototype.discardOrder = function (params) {
        var _this = this;
        console.log(params, "废弃单据");
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.cancel(params).then(function (res) {
            if (res.data.code == 76) {
                _this.$message.error(res.data.msg);
            }
            else {
                _this.$message.success(res.data.msg || "审核成功！");
            }
            _this.getList();
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PurSorting.prototype.recharge = function () {
        var _this = this;
        console.log(this.moneyForm);
        var params = {
            business_id: this.moneyForm.business,
            shop_id: this.moneyForm.shop,
            order_money: this.moneyForm.moneyNum,
            order_icomment: this.moneyForm.moneyRemark,
            order_type: 1,
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.create(params).then(function (res) {
            _this.$message.success(res.data.msg || "充值成功");
            _this.getList();
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PurSorting.prototype.deduction = function () {
        var _this = this;
        console.log(this.deductionForm);
        var params = {
            business_id: this.deductionForm.business,
            shop_id: this.deductionForm.shop,
            order_money: this.deductionForm.moneyNum,
            order_icomment: this.deductionForm.moneyRemark,
            order_type: 2,
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.create(params).then(function (res) {
            _this.$message.success(res.data.msg || "扣款成功");
            _this.getList();
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PurSorting.prototype.editOrder = function (data) {
        var tempData = JSON.stringify(data);
        this.editForm = JSON.parse(tempData);
        if (this.editForm.order_type == 2) {
            this.editForm.order_money = Math.abs(this.editForm.order_money);
        }
        this.handleEdit = true;
    };
    PurSorting.prototype.updateOrder = function () {
        var _this = this;
        var params = {
            order_id: this.editForm.order_id,
            order_money: this.editForm.order_money,
            order_icomment: this.editForm.order_icomment,
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.update(params).then(function (res) {
            _this.$message.success(res.data.msg || "修改成功");
            _this.getList();
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PurSorting.prototype.exportData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var orderIds, exportParams, codeRes, exportCode, url, checkRes, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        orderIds = this.selectedData.map(function (item) { return item.order_id; });
                        exportParams = {
                            keyword: this.formData.text,
                            time_type: this.formData.dateType,
                            s_time: this.formData.s_time,
                            e_time: this.formData.e_time,
                            shop_ids: this.formData.shop ? (this.formData.shop || []).join(',') : this.shopCode,
                            order_type: this.formData.rechargeType,
                            order_status: this.formData.rechargeStatus.join(","),
                            order_ids: orderIds.join(','),
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4, this.commonService.paramsToCode({
                                type: 113,
                                data: exportParams
                            })];
                    case 2:
                        codeRes = _a.sent();
                        if (!(codeRes.data.success && codeRes.data.data.code)) return [3, 4];
                        exportCode = codeRes.data.data.code;
                        url = "supplierclientapi/shop_finance/export?export_params_code=" + exportCode;
                        return [4, this.commonService.exportCheck(url)];
                    case 3:
                        checkRes = _a.sent();
                        if (checkRes.data.success) {
                            url = UrlHelper.addParam(url, "token", this.user.token);
                            location.href = url;
                        }
                        return [3, 5];
                    case 4: throw new Error(codeRes.data.msg || '获取导出参数失败');
                    case 5: return [3, 7];
                    case 6:
                        err_1 = _a.sent();
                        this.$message.error(err_1.msg || err_1.message || '导出失败');
                        return [3, 7];
                    case 7: return [2];
                }
            });
        });
    };
    __decorate([
        Watch("moneyForm.shop")
    ], PurSorting.prototype, "watchMoneyFormBusiness", null);
    __decorate([
        Watch("deductionForm.shop")
    ], PurSorting.prototype, "watchDeductionFormBusiness", null);
    PurSorting = __decorate([
        Component({
            components: {
                'pagination': Pagination,
                "areaShop": AreaShop
            },
            computed: __assign({}, mapGetters({
                "user": "user",
                "serviceData": 'serviceData',
                "serviceDataList": 'serviceDataList'
            }))
        })
    ], PurSorting);
    return PurSorting;
}(Vue));
export default PurSorting;
